import moment from 'moment';

import { checkType } from './Helpers';

export const validateSteps = (context, step, changeErrors) => {
  let valid = true;
  if (step === 1) {
    if (checkType(context, 'انفرادی')) {
      const users = context?.users;
      // if (users.length === 0) {
      //   valid = false;
      //   changeErrors(
      //     "single",
      //     "fillError",
      //     "لطفا شرکت کنندگان انفرادی را اضافه نمایید."
      //   );
      // } else {
      //   changeErrors("single", "fillError", undefined);
      // }
      let checkUsers = checkUsersInfo(users, context);
      if (checkUsers?.hasError) {
        valid = false;
        changeErrors('single', 'userErrors', checkUsers?.errors);
      } else {
        changeErrors('single', 'userErrors', {});
      }
    }

    if (checkType(context, 'تیمی')) {
      // if (context?.teams.length === 0) {
      //   valid = false;
      //   changeErrors(
      //     "team",
      //     "fillError",
      //     "لطفا تیم و اعضای تیم را اضافه نمایید."
      //   );
      // } else {
      //   changeErrors("team", "fillError", undefined);
      // }

      for (let team of context.teams) {
        let checkUsers = checkUsersInfo(team?.users, context);
        if (checkUsers?.hasError) {
          valid = false;
          changeErrors('team', 'teamUserErrors', checkUsers?.errors);
        } else {
          changeErrors('team', 'teamUserErrors', {});
        }
      }
    }

    if (checkType(context, 'لیگ')) {
      // if (context?.leagues.length === 0) {
      //   valid = false;
      //   changeErrors(
      //     "league",
      //     "fillError",
      //     "لطفا تیم و اعضای تیم را اضافه نمایید."
      //   );
      // } else {
      //   changeErrors("league", "fillError", undefined);
      // }
      for (let league of context.leagues) {
        let checkUsers = checkUsersInfo(league?.users, context);
        if (checkUsers?.hasError) {
          valid = false;
          changeErrors('league', 'leagueUserErrors', checkUsers?.errors);
        } else {
          changeErrors('league', 'leagueUserErrors', {});
        }
      }
    }
  }
  if (step === 2) {
    if (
      context?.competition?.coach_count > 0 &&
      context?.coaches?.length == 0
    ) {
      valid = false;
      changeErrors('coach', 'coachError', {
        message: `لطفا مربی را اضافه نمایید`,
      });
    }
    if (context?.coaches?.length > context?.competition?.coach_count) {
      valid = false;
      changeErrors('coach', 'coachError', {
        message: `تعداد مربی نباید بیشتر از ${context?.competition?.coach_count} باشد`,
      });
    }

    if (context.supervisors?.length < context?.competition?.supervisor_count) {
      valid = false;
      changeErrors('coach', 'coachError', {
        message: `لطفا سرپرست را اضافه نمایید`,
      });
    }
    // if (context.coaches?.length > context?.competition?.coach_count) {
    //   valid = false;
    //   changeErrors('coach', 'coachError', {
    //     message: `تعداد مربیان اضافه شده نمی تواند بیشتر از ${context?.competition?.coach_count} باشد.`,
    //   });
    // } else {
    //   changeErrors('coach', 'coachError', {});
    // }
    // if (context.supervisors?.length > context?.competition?.supervisor_count) {
    //   valid = false;
    //   changeErrors('supervisor', 'coachError', {
    //     message: `تعداد سرپرست های اضافه شده نمی تواند بیشتر از ${context?.competition?.supervisor_count} باشد.`,
    //   });
    // } else {
    //   changeErrors('supervisor', 'coachError', {});
    // }
  }
  return valid;
};

const checkUsersInfo = (users, context) => {
  let errrors = {};
  for (let user of users) {
    if (user?.gym == null) {
      errrors[`user.gym.${user?.id}`] = 'اضافه کردن زورخانه الزامی است';
    }

    let ageSelected = context?.competition?.ages?.find(
      (a) => a.id == user?.age_id,
    );
    let userBirthday = user?.birthday;
    const dateToCheck = moment(userBirthday);
    const startDate = moment(ageSelected?.start_age);
    const endDate = moment(ageSelected?.end_age);

    if (
      user?.sport_id == null ||
      user?.sport_id === undefined ||
      user?.sport_id?.length == 0
    ) {
      errrors[`user.sport_id.${user?.id}`] = 'انتخاب رشته الزامی است';
    }

    // if (user?.weight_id == null) {
    //   errrors[`user.weight_id.${user?.id}`] = 'انتخاب وزن الزامی است';
    // }

    if (user?.age_id == null) {
      errrors[`user.age_id.${user?.id}`] = 'انتخاب رده سنی الزامی است';
    }
    const isInRange =
      dateToCheck.isSameOrAfter(startDate) &&
      dateToCheck.isSameOrBefore(endDate);
    if (!isInRange) {
      errrors[
        `user.age_id.${user?.id}`
      ] = `سن ${user.name} ${user.last_name} با سن انتخابی مطابقت ندارد`;
    }
  }

  return {
    hasError: Object.entries(errrors)?.length > 0 ? true : false,
    errors: errrors,
  };
};
